import { useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

const BREVO_ID = '649bcb261c88d12c813d41df'

const BrevoChat = () => {
  const { t } = useTranslation()
  const [loaded, setLoaded] = useState(false)

  const loadBrevo = useCallback(() => {
    if (window.BrevoConversationsID) return

    window.BrevoConversationsID = BREVO_ID
    window.BrevoConversations = window.BrevoConversations || function () {
      (window.BrevoConversations.q = window.BrevoConversations.q || []).push(arguments)
    }

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://conversations-widget.brevo.com/brevo-conversations.js'
    script.onload = () => {
      window.BrevoConversations('openChat')
      setLoaded(true)
    }
    script.onerror = () => {
      delete window.BrevoConversationsID
    }
    document.head.appendChild(script)
  }, [])

  if (loaded) return null

  return (
    <button
      onClick={loadBrevo}
      aria-label={t('common.startChat', 'Start Chat')}
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 999,
        width: '56px',
        height: '56px',
        borderRadius: '50%',
        background: '#7C3AED',
        color: '#fff',
        border: 'none',
        cursor: 'pointer',
        boxShadow: '0 4px 12px rgba(124, 58, 237, 0.4)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '24px',
      }}
    >
      💬
    </button>
  )
}

export default BrevoChat
